module.exports = __webpack_public_path__ + "static/media/icon_accepted10px.d528d932.svg";